"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.suspenseConditionsFrontendSchema = exports.mandatoryDocumentationExtendedFrontendSchema = exports.mandatoryDocumentationFrontendSchema = exports.pendingConditionFrontendSchema = exports.suspenseConditionFrontendSchema = void 0;
var constants_1 = require("@hobt/constants");
var indicator_1 = require("../indicator");
var pending_condition_1 = require("../pending-condition");
var suspense_condition_code_1 = require("./suspense-condition-code");
exports.suspenseConditionFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['code'],
    properties: {
        code: {
            type: 'string',
            enum: Object.values(suspense_condition_code_1.SuspenseConditionCode),
            errorMessage: 'Should equate to a valid suspense conditions code enum value',
        },
        overrideReasonComment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 250,
            errorMessage: 'Should be a string with a maximum of 250 characters or null',
        },
    },
};
exports.pendingConditionFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['code'],
    properties: {
        code: {
            type: 'string',
            enum: Object.values(pending_condition_1.PendingConditionCode),
            errorMessage: 'Should equate to a valid pending conditions code enum value',
        },
        otherDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 200,
            errorMessage: 'Should be a string with a maximum of 200 characters or null',
        },
    },
    allOf: [
        {
            if: {
                required: ['code'],
                properties: {
                    code: {
                        const: pending_condition_1.PendingConditionCode.Other,
                    },
                },
            },
            then: {
                required: ['otherDescription'],
                properties: {
                    otherDescription: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 200,
                    },
                },
            },
        },
    ],
};
exports.mandatoryDocumentationFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        completeClaimReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD',
        },
        informationSentToNationalRecoveriesCentreDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        judgmentBankruptcyInformationReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
        },
        mortgageAssignmentDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
        titleTransferDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'Should follow date format YYYY-MM-DD or null',
        },
    },
};
exports.mandatoryDocumentationExtendedFrontendSchema = __assign(__assign({}, exports.mandatoryDocumentationFrontendSchema), { allOf: [
        {
            if: {
                properties: {
                    completeClaimReceivedDate: {
                        type: 'string',
                        isNotEmpty: true,
                        format: 'date',
                    },
                },
            },
            then: {
                properties: {
                    completeClaimReceivedDate: {
                        type: ['string', 'null'],
                        format: 'date',
                        errorMessage: 'Should follow date format YYYY-MM-DD',
                        notAFutureDate: true,
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    informationSentToNationalRecoveriesCentreDate: {
                        type: 'string',
                        isNotEmpty: true,
                        format: 'date',
                    },
                },
            },
            then: {
                properties: {
                    informationSentToNationalRecoveriesCentreDate: {
                        type: ['string', 'null'],
                        format: 'date',
                        isExclusivelyBeforeCurrentDay: true,
                        errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    judgmentBankruptcyInformationReceivedDate: {
                        type: 'string',
                        isNotEmpty: true,
                        format: 'date',
                    },
                },
            },
            then: {
                properties: {
                    judgmentBankruptcyInformationReceivedDate: {
                        type: ['string', 'null'],
                        format: 'date',
                        isExclusivelyBeforeCurrentDay: true,
                        errorMessage: 'should be a valid date with YYYY-MM-DD format or null',
                    },
                },
            },
        },
    ] });
exports.suspenseConditionsFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        indicator: __assign(__assign({}, indicator_1.indicatorFinalClaimSchema), { required: [] }),
        suspenseConditions: {
            type: 'array',
            items: exports.suspenseConditionFrontendSchema,
        },
        pendingConditions: {
            type: 'array',
            items: exports.pendingConditionFrontendSchema,
        },
        mandatoryDocumentation: exports.mandatoryDocumentationExtendedFrontendSchema,
    },
    allOf: [
        {
            if: {
                properties: {
                    indicator: {
                        properties: {
                            claimReceivedDate: {
                                type: 'string',
                                isNotEmpty: true,
                                format: 'date',
                            },
                        },
                    },
                    mandatoryDocumentation: {
                        properties: {
                            completeClaimReceivedDate: {
                                type: 'string',
                                isNotEmpty: true,
                                format: 'date',
                            },
                        },
                    },
                },
            },
            then: {
                properties: {
                    mandatoryDocumentation: {
                        type: ['object', 'null'],
                        properties: {
                            completeClaimReceivedDate: {
                                type: ['string', 'null'],
                                formatMinimum: {
                                    $data: '2/indicator/claimReceivedDate',
                                    customErrorMessage: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_COMPLETE_CLAIM_RECEIVED_DATE),
                                },
                            },
                        },
                    },
                },
            },
        },
    ],
};
